import { cn } from "../../lib/utils";

export interface SpinnerProps {
  /** Pixel size of the ring. */
  size?: number;
  /** Visible text for screen readers; omit when the parent already labels the state. */
  label?: string;
  className?: string;
}

/** Ring spinner in the brand colour. Use inside a role="status" container. */
export function Spinner({ size = 20, label, className }: SpinnerProps) {
  return (
    <span
      role={label ? "status" : undefined}
      className={cn("inline-flex items-center justify-center", className)}
    >
      <span
        aria-hidden="true"
        className="block animate-spin rounded-full border-2 border-primary/20 border-t-primary"
        style={{ width: size, height: size }}
      />
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}
